import React from 'react';
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
    Chip
} from '@material-tailwind/react';
import { formatAmount, formatDate, getStatusColor } from './utils/formatters';
import { getPostingStatus } from './utils/postingStatus';

const TransMessageModal = ({ open, message, onClose }) => {
    if (!message) return null;

    return (
        <Dialog open={open} handler={onClose} size="lg">
            <DialogHeader>Message Details</DialogHeader>
            <DialogBody className="max-h-96 overflow-y-auto">
                <div className="space-y-4">
                    <div>
                        <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                            Message ID:
                        </Typography>
                        <Typography variant="small" color="blue-gray" className="font-mono bg-gray-100 p-2 rounded">
                            {message.id}
                        </Typography>
                    </div>

                    <div>
                        <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                            Content:
                        </Typography>
                        <Typography variant="small" color="blue-gray" className="bg-gray-100 p-3 rounded">
                            {message.text || 'No content'}
                        </Typography>
                    </div>

                    <div>
                        <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                            Transaction Code:
                        </Typography>
                        <Typography variant="small" color="blue-gray" className="font-mono bg-gray-100 p-2 rounded">
                            {message.transaction_code || 'N/A'}
                        </Typography>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                                Status:
                            </Typography>
                            <Chip
                                variant="ghost"
                                size="sm"
                                value={getPostingStatus(message)}
                                color={getStatusColor(getPostingStatus(message))}
                            />
                        </div>
                        <div>
                            <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                                Amount:
                            </Typography>
                            <Typography variant="small" color="blue-gray">
                                {formatAmount(message.amount_extracted)}
                            </Typography>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                                Message Type:
                            </Typography>
                            <Typography variant="small" color="blue-gray">
                                {message.type || 'N/A'}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                                Created At:
                            </Typography>
                            <Typography variant="small" color="blue-gray">
                                {formatDate(message.created_at)}
                            </Typography>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                                Car ID:
                            </Typography>
                            <Typography variant="small" color="blue-gray">
                                {message.used_car || 'N/A'}
                            </Typography>
                        </div>
                        <div>
                            <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                                Driver ID:
                            </Typography>
                            <Typography variant="small" color="blue-gray">
                                {message.used_driver || 'N/A'}
                            </Typography>
                        </div>
                    </div>

                    {message.posted_at && (
                        <div>
                            <Typography variant="small" color="blue-gray" className="font-semibold mb-1">
                                Posted At:
                            </Typography>
                            <Typography variant="small" color="blue-gray">
                                {formatDate(message.posted_at)}
                            </Typography>
                        </div>
                    )}

                    {message.posting_error && (
                        <div>
                            <Typography variant="small" color="red" className="font-semibold mb-1">
                                Posting Error:
                            </Typography>
                            <Typography variant="small" color="red" className="bg-red-50 p-3 rounded">
                                {message.posting_error}
                            </Typography>
                        </div>
                    )}
                </div>
            </DialogBody>
            <DialogFooter>
                <Button variant="outlined" onClick={onClose}>
                    Close
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

export default TransMessageModal;
